var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThreedots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.98374 27.063C4.16178 27.5805 1.45459 25.7124 0.93707 22.8905C0.419548 20.0685 2.73404 17.2795 5.10963 16.8438C7.93159 16.3263 10.6388 18.1944 11.1563 21.0164C11.6738 23.8383 9.8057 26.5455 6.98374 27.063Z",
    fill: "#276850"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98374 11.1563C4.16178 11.6738 1.45459 9.80569 0.93707 6.98373C0.419548 4.16176 2.73404 1.37272 5.10963 0.937057C7.93159 0.419535 10.6388 2.28765 11.1563 5.10961C11.6738 7.93157 9.8057 10.6388 6.98374 11.1563Z",
    fill: "#276850"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8906 11.1563C20.0686 11.6738 17.3615 9.80569 16.8439 6.98373C16.3264 4.16176 18.6409 1.37272 21.0165 0.937057C23.8384 0.419535 26.5456 2.28765 27.0632 5.10961C27.5807 7.93157 25.7126 10.6388 22.8906 11.1563Z",
    fill: "#276850"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedots);
export default __webpack_public_path__ + "static/media/threedots.f078a863b1e4941a245879ea8f85eb6b.svg";
export { ForwardRef as ReactComponent };